import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Card,
  CardBody,
  CardHeader,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useDispatch } from "react-redux";

//Import actions
import {
  addNewUnit as onAddNewUnit,
  getUnits as onGetUnits,
} from "../../../slices/thunks";
import "react-toastify/dist/ReactToastify.css";

import classnames from "classnames";
import { createSelector } from "reselect";

const UnitModal = ({ show, onCloseClick, unit, blocks }) => {
  const [activeArrowTab, setactiveArrowTab] = useState(1);
  const [passedarrowSteps, setPassedarrowSteps] = useState([1]);
  const { blockId } = useParams();
  const unit_typeOptions = [
    { label: "Apartment", value: "APT" },
    { label: "Overground Parking", value: "OVER_PARK" },
    { label: "Underground Parking", value: "UNDER_PARK" },
    { label: "Storage", value: "STO" },
    { label: "Land", value: "LAND" },
    { label: "Sad", value: "SAD" },
  ];

  function toggleArrowTab(tab) {
    if (activeArrowTab !== tab) {
      var modifiedSteps = [...passedarrowSteps, tab];

      if (tab >= 1 && tab <= 4) {
        setactiveArrowTab(tab);
        setPassedarrowSteps(modifiedSteps);
      }
    }
  }

  const dispatch = useDispatch();

  const handleCloseModal = () => {
    onCloseClick();
    setactiveArrowTab(1);
    validation.resetForm();
  };
  function getValidationSchema(tab) {
    switch (tab) {
      case 1:
        return Yup.object({
          unit_type: Yup.string().required("Please Select Unit Type"),
          block: Yup.string().required("Please Select Block"),
          floor: Yup.string().required("Please Enter Floor"),
          nr: Yup.string().required("Please Enter Number"),
          initial_price: Yup.string().required("Please Enter Initial Price"),
        });
      case 2:
        return Yup.object({
          num_rooms: Yup.string().required("Please Enter Number of Rooms"),
          net_sqm: Yup.string().required("Please Enter Net Square Meters"),
          gross_sqm: Yup.string().required("Please Enter Gross Square Meters"),
          apt_net_sqm: Yup.string().required(
            "Please Enter Apartment Square Meters"
          ),
          terrace_net_sqm: Yup.string().required(
            "Please Enter Terrace Square Meters"
          ),
        });
      default:
        return Yup.object({});
    }
  }

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: (unit && unit.id) || "",
      block: (unit && unit.block) || null,
      client: (unit && unit.client) || null,
      contract: (unit && unit.contract) || null,
      settlement_price: (unit && unit.settlement_price) || null,
      unit_type: (unit && unit.unit_type) || "",
      nr: (unit && unit.nr) || "",
      initial_price: (unit && unit.initial_price) || "",
      settled_price: (unit && unit.settled_price) || null,
      cf: (unit && unit.cf) || "",
      floor: (unit && unit.floor) || "",
      num_rooms: (unit && unit.num_rooms) || "",
      net_sqm: (unit && unit.net_sqm) || "",
      gross_sqm: (unit && unit.gross_sqm) || "",
      apt_net_sqm: (unit && unit.apt_net_sqm) || "",
      terrace_net_sqm: (unit && unit.terrace_net_sqm) || "",
      apt_type: (unit && unit.apt_type) || "",
      created_at: (unit && unit.created_at) || "",
    },
    validationSchema: getValidationSchema(activeArrowTab),
    onSubmit: (values) => {
      const sanitizeValues = (values) => {
        const sanitized = { ...values };
        for (let key in sanitized) {
          if (sanitized[key] === "") {
            sanitized[key] = null;
          }
        }
        if (sanitized.active === "" || sanitized.active === null) {
          sanitized.active = true;
        }
        return sanitized;
      };

      const sanitizedValues = sanitizeValues(values);
      try {
        const newUnit = {
          block: sanitizedValues.block,
          client: sanitizedValues.client,
          contract: sanitizedValues.contract,
          unit_type: sanitizedValues.unit_type,
          settlement_price: sanitizedValues.settlement_price,
          nr: sanitizedValues.nr,
          initial_price: sanitizedValues.initial_price,
          settled_price: sanitizedValues.settled_price,
          cf: sanitizedValues.cf,
          floor: sanitizedValues.floor,
          num_rooms: sanitizedValues.num_rooms,
          net_sqm: sanitizedValues.net_sqm,
          gross_sqm: sanitizedValues.gross_sqm,
          apt_net_sqm: sanitizedValues.apt_net_sqm,
          terrace_net_sqm: sanitizedValues.terrace_net_sqm,
          apt_type: sanitizedValues.apt_type,
        };
        dispatch(onAddNewUnit(newUnit)).catch((error) => {
          console.error("Error in unit creation:", error);
        });
      } catch (error) {
        console.error("Error creating unit or payments:", error);
        alert("Failed to create unit or payments. Please try again.");
      }
      handleCloseModal();
    },
  });

  useEffect(() => {
    if (blockId && validation.values.block !== blockId) {
      validation.setFieldValue("block", blockId);
    }
  }, [blockId, show]);

  const handleNext = () => {
    validation.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        toggleArrowTab(activeArrowTab + 1);
      } else {
        validation.setTouched(
          Object.keys(validation.values).reduce((acc, key) => {
            acc[key] = true;
            return acc;
          }, {}),
          true
        );
      }
    });
  };

  return (
    <div>
      <Modal
        isOpen={show}
        toggle={onCloseClick}
        centered
        style={{
          maxWidth: "80%",
          width: "80%",
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
          "--vz-modal-bg": "transparent",
          "--vz-modal-border-color": "transparent",
        }}
      >
        <Form
          className="tablelist-form"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="page-content">
              <Row>
                <Card>
                  <CardHeader>
                    <div className="hstack gap-2 justify-content-end">
                      <Button
                        className="btn btn-light"
                        color="secondary"
                        onClick={handleCloseModal}
                      >
                        <i className="ri-close-line"></i>
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody className="form-steps">
                    <div className="step-arrow-nav mb-4">
                      <Nav
                        className="nav-pills custom-nav nav-justified"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            id="steparrow-gen-info-tab"
                            className={classnames({
                              active: activeArrowTab === 1,
                              done: activeArrowTab <= 4 && activeArrowTab > 0,
                            })}
                          >
                            Create Unit
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            id="steparrow-gen-info-tab"
                            className={classnames({
                              active: activeArrowTab === 2,
                              done: activeArrowTab <= 4 && activeArrowTab > 1,
                            })}
                          >
                            Unit Details
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>

                    <TabContent activeTab={activeArrowTab}>
                      <TabPane id="steparrow-gen-info" tabId={1}>
                        <div style={{ padding: "0px 100px" }}>
                          <Row>
                            <Col>
                              <div className="mb-3">
                                <Label
                                  htmlFor="id-field"
                                  className="form-label"
                                >
                                  Unit Type
                                </Label>
                                <Input
                                  name="unit_type"
                                  type="select"
                                  className="form-select"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.unit_type ?? ""}
                                  invalid={
                                    !!(
                                      validation.touched.unit_type &&
                                      validation.errors.unit_type
                                    )
                                  }
                                >
                                  <option value="">Select Unit Type</option>{" "}
                                  {unit_typeOptions.map((option, index) => (
                                    <option value={option.value} key={index}>
                                      {option.label}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.unit_type &&
                                validation.errors.unit_type ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.unit_type}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col>
                              <div className="mb-3">
                                <Label
                                  htmlFor="blocks-field"
                                  className="form-label"
                                >
                                  Blocks
                                </Label>
                                <Input
                                  type="select"
                                  name="block"
                                  id="block-field"
                                  className="form-select"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.block || ""}
                                  invalid={
                                    !!(
                                      validation.touched.block &&
                                      validation.errors.block
                                    )
                                  }
                                >
                                  <option value="">Select a Block</option>
                                  {blocks.map((block) => (
                                    <option key={block.id} value={block.id}>
                                      {block.name}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.block &&
                                  validation.errors.block && (
                                    <FormFeedback type="invalid">
                                      {validation.errors.block}
                                    </FormFeedback>
                                  )}
                              </div>
                            </Col>
                          </Row>
                          <div className="mb-3">
                            <div>
                              <Label
                                htmlFor="customername-field"
                                className="form-label"
                              >
                                Floor
                              </Label>
                              <Input
                                name="floor"
                                id="customername-field"
                                className="form-control"
                                placeholder="Enter Floor"
                                type="number"
                                step="1"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.floor ?? ""}
                                invalid={
                                  !!(
                                    validation.touched.floor &&
                                    validation.errors.floor
                                  )
                                }
                              />
                              {validation.touched.floor &&
                              validation.errors.floor ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.floor}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>
                          <div className="mb-3">
                            <div>
                              <Label htmlFor="id-field" className="form-label">
                                Number
                              </Label>
                              <Input
                                name="nr"
                                id="id-field"
                                className="form-control"
                                placeholder="Enter number"
                                type="number"
                                step="1"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.nr || ""}
                                invalid={
                                  !!(
                                    validation.touched.nr &&
                                    validation.errors.nr
                                  )
                                }
                              />
                              {validation.touched.nr && validation.errors.nr ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.nr}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>

                          <div className="mb-3">
                            <Label
                              htmlFor="customername-field"
                              className="form-label"
                            >
                              Initial Price
                            </Label>
                            <Input
                              name="initial_price"
                              id="customername-field"
                              className="form-control"
                              placeholder="Enter Amount"
                              type="number"
                              step="0.01"
                              validate={{
                                required: { value: true },
                              }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.initial_price || ""}
                              invalid={
                                !!(
                                  validation.touched.initial_price &&
                                  validation.errors.initial_price
                                )
                              }
                            />
                            {validation.touched.initial_price &&
                            validation.errors.initial_price ? (
                              <FormFeedback type="invalid">
                                {validation.errors.initial_price}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label
                              htmlFor="amount-field"
                              className="form-label"
                            >
                              CF
                            </Label>
                            <Input
                              name="cf"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.cf || ""}
                              invalid={
                                !!(
                                  validation.touched.cf && validation.errors.cf
                                )
                              }
                            />
                            {validation.touched.cf && validation.errors.cf ? (
                              <FormFeedback type="invalid">
                                {validation.errors.cf}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </div>
                        <div className="d-flex align-items-start gap-3 mt-4">
                          <button
                            type="button"
                            className="btn btn-success btn-label right ms-auto nexttab nexttab"
                            onClick={() => {
                              handleNext();
                            }}
                          >
                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                            Next
                          </button>
                        </div>
                      </TabPane>

                      <TabPane id="steparrow-description-info" tabId={2}>
                        <div style={{ padding: "0px 100px" }}>
                          <div className="mb-3">
                            <Label
                              htmlFor="amount-field"
                              className="form-label"
                            >
                              Number of Rooms
                            </Label>
                            <Input
                              name="num_rooms"
                              type="number"
                              placeholder="Enter number"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.num_rooms ?? ""}
                              invalid={
                                !!(
                                  validation.touched.num_rooms &&
                                  validation.errors.num_rooms
                                )
                              }
                            />

                            {validation.touched.num_rooms &&
                            validation.errors.num_rooms ? (
                              <FormFeedback type="invalid">
                                {validation.errors.num_rooms}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label
                              htmlFor="amount-field"
                              className="form-label"
                            >
                              Net Sqm
                            </Label>
                            <Input
                              name="net_sqm"
                              type="number"
                              step="0.01"
                              placeholder="Enter number"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.net_sqm ?? ""}
                              invalid={
                                !!(
                                  validation.touched.net_sqm &&
                                  validation.errors.net_sqm
                                )
                              }
                            />
                            {validation.touched.net_sqm &&
                            validation.errors.net_sqm ? (
                              <FormFeedback type="invalid">
                                {validation.errors.net_sqm}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label
                              htmlFor="amount-field"
                              className="form-label"
                            >
                              Gross Sqm
                            </Label>
                            <Input
                              name="gross_sqm"
                              type="number"
                              step="0.01"
                              placeholder="Enter number"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.gross_sqm ?? ""}
                              invalid={
                                !!(
                                  validation.touched.gross_sqm &&
                                  validation.errors.gross_sqm
                                )
                              }
                            />
                            {validation.touched.gross_sqm &&
                            validation.errors.gross_sqm ? (
                              <FormFeedback type="invalid">
                                {validation.errors.gross_sqm}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label
                              htmlFor="amount-field"
                              className="form-label"
                            >
                              Apartment Net Sqm
                            </Label>
                            <Input
                              name="apt_net_sqm"
                              type="number"
                              step="0.01"
                              placeholder="Enter number"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.apt_net_sqm ?? ""}
                              invalid={
                                !!(
                                  validation.touched.apt_net_sqm &&
                                  validation.errors.apt_net_sqm
                                )
                              }
                            />
                            {validation.touched.apt_net_sqm &&
                            validation.errors.apt_net_sqm ? (
                              <FormFeedback type="invalid">
                                {validation.errors.apt_net_sqm}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label
                              htmlFor="amount-field"
                              className="form-label"
                            >
                              Terrace Net Sqm
                            </Label>
                            <Input
                              name="terrace_net_sqm"
                              type="number"
                              step="0.01"
                              placeholder="Enter number"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.terrace_net_sqm ?? ""}
                              invalid={
                                !!(
                                  validation.touched.terrace_net_sqm &&
                                  validation.errors.terrace_net_sqm
                                )
                              }
                            />
                            {validation.touched.terrace_net_sqm &&
                            validation.errors.terrace_net_sqm ? (
                              <FormFeedback type="invalid">
                                {validation.errors.terrace_net_sqm}
                              </FormFeedback>
                            ) : null}
                          </div>

                          {validation.values.unit_type == "APT" && (
                            <div className="mb-3">
                              <Label
                                htmlFor="amount-field"
                                className="form-label"
                              >
                                Apartment Type
                              </Label>
                              <span className="text-muted">(optional)</span>
                              <Input
                                name="apt_type"
                                type="text"
                                placeholder="Enter Type"
                                onChange={validation.handleChange}
                                // onBlur={validation.handleBlur}
                                value={validation.values.apt_type || null}
                                // invalid={
                                //     !!(validation.touched.apt_type && validation.errors.apt_type)
                                // }
                              />
                              {/* {validation.touched.apt_type && validation.errors.apt_type ? (
                                            <FormFeedback type="invalid">{validation.errors.apt_type}</FormFeedback>
                                            ) : null} */}
                            </div>
                          )}
                        </div>
                        <div className="d-flex align-items-start gap-3 mt-4">
                          <button
                            type="button"
                            className="btn btn-light btn-label previestab"
                            onClick={() => {
                              toggleArrowTab(activeArrowTab - 1);
                            }}
                          >
                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                            Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success btn-label right ms-auto nexttab nexttab"
                          >
                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                            Submit
                          </button>
                        </div>
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              </Row>
            </div>
          </ModalBody>
        </Form>
      </Modal>
    </div>
  );
};

export default UnitModal;
